import { gql } from "@apollo/client";

import { PERFORMANCE_GRAPH_FRAGMENT } from "@graphql/fragments";

export const GOAL_DETAILS_BREAKDOWN = gql`
  ${PERFORMANCE_GRAPH_FRAGMENT}

  query goalDetailsBreakdown($beneficiaryId: String, $goalId: String!, $nodeCount: Int) {
    oneDay: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_DAY
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneWeek: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_WEEK
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneMonth: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_MONTH
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    sixMonth: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: SIX_MONTH
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneYear: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_YEAR
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    fiveYear: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: FIVE_YEAR
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    portfolioBreakdown(input: { goalId: $goalId }) {
      totalValueInCents
      contributionsInCents
      returnsInCents
      sectorExposures {
        name
        factorPercentage
      }
      assetClassExposures {
        name
        factorPercentage
      }
    }
    portfolioPositions(input: { beneficiaryId: $beneficiaryId, goalId: $goalId }) {
      symbol
      name
      shares
      sharePriceInCents
      totalValueInCents
      changeTodayAmountInCents
      changeTodayPercentage
    }
  }
`;

export const HARVEST_ACCOUNT_DEFAULT_CONFIGS = gql`
  query harvestAccountDefaultConfigs {
    harvestAccountDefaultConfigs(input: {}) {
      harvestStandardDeduction
      harvestLongTermCapitalGains
      harvestRecommendedFloorUsd
      reason
    }
  }
`;

export const SENT_SHARE_GOAL_INVITES = gql`
  query sentShareGoalInvites($goalId: String!) {
    sentShareGoalInvites(goalId: $goalId) {
      id
      goalId
      phoneNumber
      status
      expiry
    }
  }
`;

export const RECEIVED_SHARE_GOAL_INVITES = gql`
  query receivedShareGoalInvites {
    receivedShareGoalInvites {
      id
      goalName
      goalType
      beneficiaryType
      inviterFirstName
      inviterLastName
      currentAmountInCents
      targetAmountInCents
      targetYear
      startDate
      endDate
      projectedRateOfReturn
      contributionsAfter18
      recurringDepositInCents
      recurringDepositSchedule
      partnerGoalContributions {
        partnerId
        partnerFirstName
        partnerLastName
        recurringDepositInCents
        recurringDepositSchedule
      }
      status
      expiry
    }
  }
`;

export const SUGGESTED_ACCOUNT_TYPE = gql`
  query suggestedAccountType($input: SuggestedAccountTypeInput!) {
    suggestedAccountType(input: $input) {
      recommended
      alternatives
    }
  }
`;
